import React from "react";
import { Form, Spinner, Row, Col } from "react-bootstrap";
import Select from "react-select";
import type { AcademyListItem } from "../../../../api/academyEnrolments/enrolmentsService";

interface AcademySectionProps {
  academyList: AcademyListItem[];
  selectedAcademy: AcademyListItem | null;
  selectedSport: string;
  loadingAcademies: boolean;
  onAcademySelect: (a: AcademyListItem) => void;
  onSportSelect: (s: string) => void;
  disabled?: boolean;
}

const AcademySection: React.FC<AcademySectionProps> = ({
  academyList,
  selectedAcademy,
  selectedSport,
  loadingAcademies,
  onAcademySelect,
  onSportSelect,
  disabled,
}) => {
  const academyOptions = academyList.map((a) => ({
    value: a._id,
    label: a.basicDetails.academyName,
    academy: a,
  }));

  const sportOptions =
    selectedAcademy?.basicDetails.sports.map((s) => ({ value: s, label: s })) ?? [];

  const autoSingleSport =
    selectedAcademy?.basicDetails.sports.length === 1;

  return (
    <div className="enrolment-form-section">
      <h6 className="enrolment-section-title">
        <span className="enrolment-section-number">4</span>
        Academy &amp; Sport
      </h6>

      <Row className="g-3">
        <Col xs={12} md={6}>
          <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
            Academy *
          </Form.Label>
          {disabled ? (
            <div className="enrolment-readonly-field-wrapper">
              <Form.Control
                readOnly
                value={selectedAcademy?.basicDetails.academyName ?? "—"}
                style={{ pointerEvents: "none" }}
              />
            </div>
          ) : (
            <Select
              classNamePrefix="react-select"
              options={academyOptions}
              isLoading={loadingAcademies}
              isDisabled={disabled}
              value={
                selectedAcademy
                  ? {
                      value: selectedAcademy._id,
                      label: selectedAcademy.basicDetails.academyName,
                      academy: selectedAcademy,
                    }
                  : null
              }
              onChange={(opt) => opt && onAcademySelect(opt.academy)}
              placeholder="Select academy..."
            />
          )}
        </Col>

        {selectedAcademy && (
          <Col xs={12} md={4}>
            <Form.Label className="mb-1 text-muted" style={{ fontSize: 12 }}>
              Sport *
            </Form.Label>
            {disabled || autoSingleSport ? (
              <div
                className={disabled ? "enrolment-readonly-field-wrapper" : undefined}
              >
                <Form.Control
                  readOnly
                  value={selectedSport || "—"}
                  style={disabled ? { pointerEvents: "none" } : undefined}
                />
              </div>
            ) : (
              <Select
                classNamePrefix="react-select"
                options={sportOptions}
                isDisabled={disabled}
                value={
                  selectedSport ? { value: selectedSport, label: selectedSport } : null
                }
                onChange={(opt) => opt && onSportSelect(opt.value)}
                placeholder="Select sport..."
              />
            )}
            {autoSingleSport && (
              <span className="text-muted" style={{ fontSize: 11 }}>
                Auto-selected (only sport offered)
              </span>
            )}
          </Col>
        )}
      </Row>
    </div>
  );
};

export default AcademySection;
